import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import img from '../images/homepage.gif';
import ContactModal from './ContactModal';

const Intro = () => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <div className="w-full px-8 sm:px-12 md:px-16 lg:px-20 py-16 md:py-24 relative" id='about'>
                <div className="flex flex-col lg:flex-row gap-10 items-center max-w-7xl mx-auto" data-aos="fade-up">
                    <div className="flex-col text-left w-full lg:w-1/2" data-aos="zoom-in" data-aos-delay="300">
                        <p className="text-sm sm:text-base text-gray-500 font-semibold tracking-wider mb-2 uppercase">
                            {t('intro.about_title')}
                        </p>
                        <div className="flex items-center gap-4 mb-6">
                            <h2 className="text-3xl sm:text-4xl lg:text-5xl text-blue-900 font-bold leading-tight">
                                {t('intro.company_name')}
                            </h2>
                            <div className="h-1 w-32 bg-blue-700"></div>
                        </div>
                        
                        <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4 font-semibold">
                            {t('intro.main_heading')}
                        </p>
                        
                        <div className="space-y-4 text-gray-700">
                            <p className='text-base sm:text-lg lg:text-xl leading-relaxed'>
                                {t('intro.paragraph_1')}
                            </p>
                            <p className='text-base sm:text-lg lg:text-xl leading-relaxed'>
                                {t('intro.paragraph_2')}
                            </p>
                            <p className='text-base sm:text-lg lg:text-xl leading-relaxed'>
                                {t('intro.paragraph_3')}
                            </p>
                            <p className='text-base sm:text-lg lg:text-xl leading-relaxed'>
                                {t('intro.paragraph_4')}
                            </p>
                        </div>
                        
                        <button 
                            onClick={() => setIsModalOpen(true)}
                            className="px-8 py-3 mt-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
                        >
                            {t('intro.contact_btn')}
                        </button>
                    </div>

                    <div className="w-full lg:w-1/2 flex justify-center lg:ml-16 relative">
                         <div className="w-80 h-80 sm:w-[450px] sm:h-[450px] rounded-full border-8 border-blue-700 overflow-hidden">
                            <img alt="Lak-Che" className="w-full h-full object-cover" src={img} />
                        </div>
                    </div>
                </div>
            </div>
            <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
    );
};

export default Intro;